import React, { useState, useEffect } from 'react'
import { Formik, Form, Field, getIn } from 'formik'
import ReCAPTCHA from 'react-google-recaptcha'
import Required from 'src/components/Required'
import ErrorMessage from 'src/components/ErrorMessage'
import { useSelector } from 'react-redux'
import { contentPage } from 'src/services/ContentApi'
import Loader from 'src/components/Loader'
import { validationHelplineSchema } from 'src/lib/Validation'
import { scrollToError } from 'src/lib/utils'
import { PostHelpline } from 'src/services/user'
import { helplineValues } from 'src/lib/InitialValues'
import PropTypes from 'prop-types'
import TextareaFieldWrapper from 'src/components/TextareaFieldWrapper'
import ReadSpeakerButton from 'src/components/ReadSpeakerButton'
import SetInnerHtml from 'src/components/SetInnerHtml'
let recaptchaInstance
const resetRecaptcha = () => {
  recaptchaInstance.reset()
}
const Helpline = ({ onHide }) => {
  const language = useSelector((state) => state.language)
  const [myData, setMyData] = useState({})
  const [loader, setLoader] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [message, setMessage] = useState('')

  const handleSubmit = async (values) => {
    resetRecaptcha()
    delete values?.option
    delete values?.reCaptcha
    delete values?.yesOrno

    if (values?.options) {
      Object.keys(values.options).forEach((key) => {
        if (values.options[key] === '') {
          if (key === 'mailing') {
            values.mailingAddress = ''
          } else if (key === 'other') {
            values.otherContact = ''
          } else {
            values[key] = ''
          }
        }
      })
    }
    delete values?.options
    if (!['3', '4'].includes(values.helplineSource)) {
      values.helplineSourceOther = ''
    }
    if (values?.problemSource !== '5') {
      values.problemSourceOther = ''
    }
    values.languageId = language
    setIsSubmitted(true)
    const { data } = await PostHelpline(values)
    if (data.status === 'SUCCESS') {
      setMessage(myData.html_successmessage)
    } else {
      setMessage(myData.html_errormessage)
    }
  }

  const getData = async () => {
    setLoader(true)
    const [pageData] = await Promise.all([contentPage('page_helpline', language)])
    setMyData(pageData)
    setLoader(false)
  }
  useEffect(() => {
    getData()
  }, [language])
  const handleChoiceChange = (value, formik, name) => {
    const { values, setFieldValue } = formik
    const selectedOptions = getIn(values, 'option') || []
    if (selectedOptions.includes(value)) {
      const updatedOptions = selectedOptions.filter((option) => option !== value)
      setFieldValue('option', updatedOptions)
      setFieldValue(name, '')
    } else {
      setFieldValue(name, value)
      setFieldValue('option', [...selectedOptions, value])
    }
  }

  const problemOptions = [
    { value: '1', label: myData?.txt_problem1 },
    { value: '2', label: myData?.txt_problem2 },
    { value: '3', label: myData?.txt_problem3 },
    { value: '4', label: myData?.txt_problem4 },
    { value: '5', label: myData?.txt_problem5 },
  ]

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <section className="helpline-container">
          <h2>{myData?.txt_header}</h2>
          {!isSubmitted ? (
            <Formik
              initialValues={helplineValues}
              validationSchema={validationHelplineSchema}
              onSubmit={handleSubmit}
              validateOnMount
            >
              {(formik) => {
                const { setFieldValue, errors, touched, values } = formik
                return (
                  <Form className="container-fluid" id="helpline_form">
                    <div className="row">
                      <div className="col-md-12">
                        <Required />
                        <div className="row">
                          <div className="col-sm-12">
                            <ReadSpeakerButton id={'readspkid'} />
                            <div className="clearfix">
                              <div className="qu_prefix">1.</div>
                              <div className="qu_text">
                                {myData?.txt_yourname} <span className="asterisk-reuqired">*</span>
                              </div>
                            </div>
                            <div className="qu_controls form-group">
                              <Field
                                name="name"
                                type="text"
                                className={`form-control ${touched.name && errors.name ? 'is-invalid' : ''}`}
                              />
                              <ErrorMessage name="name" formik={formik} />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12 lblgroup">
                            <ReadSpeakerButton id={'readspkid'} />
                            <div>
                              <div className="clearfix">
                                <div className="qu_prefix">2.</div>
                                <div className="qu_text">
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: myData?.txt_bestwayquestion,
                                    }}
                                  />
                                  <span className="asterisk-reuqired">*</span>
                                </div>
                              </div>
                            </div>
                            <div className="qu_choices">
                              <div className="checkbox">
                                <Field
                                  id="emailChoice"
                                  type="radio"
                                  className="group3"
                                  name={`options.email`}
                                  value="email"
                                  checked={getIn(values, 'options.email') === 'email'}
                                  onClick={(e) =>
                                    handleChoiceChange(e.target.value, formik, `options.email`)
                                  }
                                />
                                <label htmlFor="emailChoice">{myData?.txt_email}</label>
                              </div>

                              {getIn(values, 'option').includes('email') && (
                                <div className="other-input3 qu_controls form-group">
                                  <Field
                                    className={`form-control ${touched.email && errors.email ? 'is-invalid' : ''}`}
                                    id="helplineemail"
                                    name="email"
                                    type="email"
                                    placeholder="Enter your email"
                                  />
                                  <ErrorMessage name="email" formik={formik} />
                                </div>
                              )}
                              <div className="checkbox">
                                <Field
                                  id="phone"
                                  type="radio"
                                  className="group4"
                                  name={`options.phone`}
                                  value="phone"
                                  checked={getIn(values, 'options.phone') === 'phone'}
                                  onClick={(e) =>
                                    handleChoiceChange(e.target.value, formik, `options.phone`)
                                  }
                                />
                                <label htmlFor="phone">{myData?.txt_phone}</label>
                              </div>
                              {getIn(values, 'options.phone') === 'phone' && (
                                <>
                                  <div className="other-input4 hidden qu_controls form-group">
                                    <Field
                                      className={`form-control date-input ${getIn(touched, 'phone') && getIn(errors, 'phone') ? 'is-invalid' : ''}`}
                                      id="phoneno"
                                      name="phone"
                                      type="tel"
                                      pattern="(?:\(\d{3}\)|\d{3})[- ]?\d{3}[- ]?\d{4}"
                                    />
                                    <div className="help-text">
                                      &nbsp;&nbsp;xxx-xxx-xxxx (e.g. &quot;123-456-7890&quot;)
                                    </div>
                                  </div>
                                  <ErrorMessage className="ms-4" name="phone" formik={formik} />
                                </>
                              )}
                              <div className="checkbox">
                                <Field
                                  id="mailing"
                                  type="radio"
                                  className="group5"
                                  name={`options.mailing`}
                                  value="mailing"
                                  checked={getIn(values, 'options.mailing') === 'mailing'}
                                  onClick={(e) =>
                                    handleChoiceChange(e.target.value, formik, `options.mailing`)
                                  }
                                />
                                <label htmlFor="mailing">{myData?.txt_anotherway}</label>
                              </div>
                              {getIn(values, 'options.mailing') === 'mailing' && (
                                <TextareaFieldWrapper
                                  className="mt-2 ms-3"
                                  name="mailingAddress"
                                  formik={formik}
                                />
                              )}
                              <div className="checkbox">
                                <Field
                                  id="other"
                                  type="radio"
                                  name={`options.other`}
                                  value="other"
                                  checked={getIn(values, 'options.other') === 'other'}
                                  onClick={(e) =>
                                    handleChoiceChange(e.target.value, formik, `options.other`)
                                  }
                                />
                                <label htmlFor="other">{myData?.txt_option4}</label>
                              </div>
                              {getIn(values, 'options.other') === 'other' && (
                                <TextareaFieldWrapper
                                  className="mt-2 ms-3"
                                  name="otherContact"
                                  formik={formik}
                                />
                              )}
                              <ErrorMessage name="option" formik={formik} />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12 lblgroup">
                            <ReadSpeakerButton id={'readspkid'} />
                            <div>
                              <div className="clearfix">
                                <div className="qu_prefix">3.</div>
                                <div className="qu_text">
                                  {myData?.txt_chooseone}{' '}
                                  <span className="asterisk-reuqired">*</span>
                                </div>
                              </div>
                            </div>
                            <div className="qu_choices">
                              <div className="checkbox">
                                <Field id="help1" type="radio" name="helplineSource" value="1" />
                                <label htmlFor="help1">{myData?.txt_option1}</label>
                              </div>
                              <div className="checkbox">
                                <Field id="help2" type="radio" name="helplineSource" value="2" />
                                <label htmlFor="help2">{myData?.txt_option2}</label>
                              </div>
                              <div className="checkbox">
                                <Field id="help3" type="radio" name="helplineSource" value="3" />
                                <label htmlFor="help3">{myData?.txt_option3}</label>
                              </div>
                              {getIn(values, 'helplineSource') === '3' && (
                                <div className="other-input1 hidden qu_controls">
                                  {myData?.txt_option3question}
                                  <Field
                                    className={`form-control ${touched.helplineSourceOther && errors.helplineSourceOther ? 'is-invalid' : ''}`}
                                    name="helplineSourceOther"
                                    type="text"
                                  />
                                  <ErrorMessage name="helplineSourceOther" formik={formik} />
                                </div>
                              )}
                              <div className="checkbox">
                                <Field id="help4" type="radio" name="helplineSource" value="4" />
                                <label htmlFor="help4">{myData?.txt_option4}</label>
                              </div>
                              {getIn(values, 'helplineSource') === '4' && (
                                <div className="other-input1 hidden qu_controls">
                                  {myData?.txt_option4question}
                                  <Field
                                    className={`form-control ${touched.helplineSourceOther && errors.helplineSourceOther ? 'is-invalid' : ''}`}
                                    name="helplineSourceOther"
                                    type="text"
                                  />
                                  <ErrorMessage name="helplineSourceOther" formik={formik} />
                                </div>
                              )}
                              <ErrorMessage name="helplineSource" formik={formik} />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-12 lblgroup">
                            <ReadSpeakerButton id={'readspkid'} />
                            <div>
                              <div className="clearfix">
                                <div className="qu_prefix">4.</div>
                                <div className="qu_text">
                                  {myData?.txt_typeofproblem}
                                  <span className="asterisk-reuqired">*</span>
                                </div>
                              </div>
                            </div>
                            <div className="qu_choices">
                              {problemOptions.map((option) => (
                                <div key={option.value} className="checkbox">
                                  <Field
                                    type="radio"
                                    id={option.value}
                                    name="problemSource"
                                    value={option.value}
                                  />
                                  <label htmlFor={option.value}> {option.label}</label>
                                </div>
                              ))}
                              {getIn(values, 'problemSource') === '5' && (
                                <TextareaFieldWrapper
                                  label={myData?.txt_problem5question}
                                  className="mt-2 ms-3"
                                  name="problemSourceOther"
                                  formik={formik}
                                />
                              )}
                              <ErrorMessage name="problemSource" formik={formik} />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-12">
                            <ReadSpeakerButton id={'readspkid'} />
                            <div>
                              <div className="clearfix">
                                <div className="qu_prefix">5.</div>
                                <div className="qu_text">
                                  {myData?.txt_description}{' '}
                                  <span className="asterisk-reuqired">*</span>
                                </div>
                              </div>
                              <TextareaFieldWrapper
                                className="ms-4"
                                name="question"
                                formik={formik}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="pt-3">
                              <ReadSpeakerButton id={'readspkid'} />
                            </div>
                            <div className="clearfix">
                              <div className="qu_prefix">6.</div>
                              <div className="qu_text">
                                {myData.txt_q6text}
                                <span className="asterisk-required">*</span>
                              </div>
                            </div>
                            <div className="qu_choices">
                              <div className="checkbox">
                                <Field
                                  id="yes"
                                  className="other group7"
                                  name="yesOrno"
                                  type="radio"
                                  value="yes"
                                  onChange={() => {
                                    setFieldValue('yesOrno', 'yes')
                                  }}
                                />
                                <label htmlFor="yes"> {myData.txt_q6_choice1_text}</label>
                              </div>
                              {getIn(values, 'yesOrno') === 'yes' && (
                                <TextareaFieldWrapper
                                  className="ms-4 mt-2"
                                  name="otherInfo"
                                  formik={formik}
                                />
                              )}
                              <div className="checkbox">
                                <Field
                                  className="group7"
                                  id="no"
                                  name="yesOrno"
                                  type="radio"
                                  value="no"
                                  onChange={() => {
                                    setFieldValue('yesOrno', 'no')
                                    setFieldValue('otherInfo', '')
                                  }}
                                />
                                <label htmlFor="no"> {myData.txt_q6_choice2_text}</label>
                              </div>
                              <ErrorMessage name="yesOrno" formik={formik} />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12">
                            <ReCAPTCHA
                              ref={(e) => (recaptchaInstance = e)}
                              hl={language === '2' ? 'es' : 'en'}
                              sitekey="6LehNfoUAAAAAObCNrLwoWbS1QS89Fv2ldd9tBNQ"
                              onChange={(value) => {
                                formik.setFieldValue('reCaptcha', value)
                              }}
                              verifyCallback={(response) => {}}
                              onloadCallback={() => {}}
                            />
                            <ErrorMessage name="reCaptcha" formik={formik} />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12 text-center">
                            <div className="form-group">
                              <button
                                className="btn btn-default btn-primary w-50"
                                id="btnhelplineSave"
                                name="submit"
                                type="submit"
                                onClick={() => {
                                  if (Object.keys(formik.errors).length > 0) {
                                    scrollToError(formik.errors)
                                  }
                                }}
                              >
                                {myData?.txt_sendbutton}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                )
              }}
            </Formik>
          ) : (
            <div className="container-fluid" id="newsletter_confirm">
              {message === '' ? (
                <Loader />
              ) : (
                <>
                  <div className="row">
                    <SetInnerHtml
                      tag="div"
                      className="col-md-12 text-center py-5"
                      content={message}
                    />
                  </div>
                  <div className="row">
                    <div className="col-sm-12 text-center">
                      <div className="form-group">
                        <button
                          className="btn btn-default btn-primary w-50"
                          id="newsletterClose"
                          name="close"
                          onClick={() => {
                            setIsSubmitted(false)
                            onHide()
                          }}
                        >
                          {myData.txt_closebuttontext}
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
        </section>
      )}
    </>
  )
}

Helpline.propTypes = {
  onHide: PropTypes.func,
}

export default Helpline
